import { createFileRoute } from "@tanstack/react-router";
import { StudyAbroadPage } from "@/components/abroad/StudyAbroadPage";
import { abroadHead } from "@/components/abroad/abroad-head";
import { getEduCountriesCount, type CountriesHead } from "@/lib/edu-countries-count.functions";

// Лендинг «Учёба за рубежом» (ru). Адреса трёх языков — ABROAD_PATH.
export const Route = createFileRoute("/study-abroad")({
  // Число открытых стран — для FAQ («в подборе N стран») и его JSON-LD. Сбой — без числа.
  loader: async (): Promise<CountriesHead | null> => {
    try {
      return await getEduCountriesCount();
    } catch {
      return null;
    }
  },
  head: ({ loaderData }) => abroadHead("ru", loaderData?.count ?? null),
  component: function Page() {
    const data = Route.useLoaderData();
    return <StudyAbroadPage lang="ru" countries={data?.count ?? null} />;
  },
});
